export const green = "#036b36";//"#053220";
export const lightGreen = "#7ad446";//"#098B54";
export const red = "#FF5252";
export const blue = "#5687FF";
export const primaryGreen = "#2D8C3C";
export const black = "#111111";
